import { useMutation, useQuery } from '@apollo/client'
import { Select } from 'antd'
import { DEMANDE_UPDATE } from '../../../apollo/mutation/demande.mutation'
import { ASSURANCES_QUERY } from '../../../apollo/query/assurance.query'
import { D4_Assurance } from '../../../types'

const ENUM = {
  0: 'Multi-Risques Immeuble',
  1: 'Dommage Ouvrage',
  2: 'Responsabilité Civile',
  3: 'Protection Juridique',
} as any

type Props = {
    coproprieteId: number
    assuranceId: number
    demandeId: number
}

const SelectAssurance = ({
  coproprieteId,
  demandeId,
  assuranceId,
}: Props) => {
  const { data } = useQuery<{ assurances: D4_Assurance[] }, { coproprieteId: number }>(ASSURANCES_QUERY, {
    variables: { coproprieteId },
  })
  const [updateDemande] = useMutation(DEMANDE_UPDATE)

  if (!data) return null

  const options = data.assurances.map((assurance) => ({
    label: `${ENUM[assurance.typeassurance]} ${assurance.compagniedassurance?.raisonsociale} - ${
      assurance.courtier?.raisonsociale
    } - ${assurance.police}`,
    value: assurance.id,
  }))

  const handleChangeAssurance = (id: number) => {
    updateDemande({
      variables: {
        id: demandeId,
        data: { assurance_id: id },
      },
    })
  }

  return (
    <Select
      listHeight={800}
      defaultValue={assuranceId}
      placeholder="Assurances"
      style={{ width: '100%' }}
      options={options}
      onSelect={handleChangeAssurance}
    />
  )
}

export default SelectAssurance
